import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-print",
  "use": "icon-print-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"currentColor\" id=\"icon-print\">\n  <path d=\"M14.588,13.53h-0.706v2.118H6.118V13.53H5.412C4.244,13.53,4,13.285,4,12.118 v-3.53C4,7.81,4.633,7.176,5.412,7.176h0.706V4.353h7.765v2.824l0,0C15.05,7.177,16,8.126,16,9.294v2.824 C16,13.285,15.756,13.53,14.588,13.53z M7.529,14.235h4.941v-3.53H7.529V14.235z M12.471,5.765H7.529v1.412l4.941,0V5.765z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol